// ========================
// Game Settings
// ========================

export const GAME_CONFIG = {
  TARGET_FPS: 60,
  FIXED_DELTA_TIME: 1 / 60,

  // Canvas
  DEFAULT_WIDTH: 1920,
  DEFAULT_HEIGHT: 1080,
  ASPECT_RATIO: 16 / 9,

  // Isometric
  TILE_WIDTH: 64,
  TILE_HEIGHT: 32,
} as const;

// ========================
// Character Constants
// ========================

export const MAX_LEVEL = 100;
export const SKILL_POINTS_PER_LEVEL = 1;

/** Sınıfsız sistem: herkes aynı başlangıç değerleriyle başlar */
export const BASE_STATS = {
  strength: 10,
  agility: 10,
  spirit: 10,
  hp: 100,
  mana: 80,
} as const;

/** @deprecated Eski sınıf bazlı stat'lar. Kaldırılacak. */
export const LEGACY_CLASS_STATS = {
  alp: { strength: 14, agility: 8, spirit: 8, hp: 120, mana: 50 },
  kam: { strength: 8, agility: 8, spirit: 14, hp: 80, mana: 120 },
  mergen: { strength: 8, agility: 14, spirit: 8, hp: 90, mana: 70 },
  boru: { strength: 10, agility: 12, spirit: 8, hp: 100, mana: 60 },
} as const;

// ========================
// Combat Constants
// ========================

export const COMBAT = {
  // Armor formula: reduction = armor / (armor + 10 * enemyLevel)
  ARMOR_CONSTANT: 10,
  MAX_ARMOR_REDUCTION: 0.9, // 90% cap

  // Resistance caps
  MAX_ELEMENTAL_RESISTANCE: 0.75, // 75%
  MAX_CHAOS_RESISTANCE: 0.5, // 50% - karanlık hasar direnci daha düşük cap

  // Critical
  BASE_CRIT_CHANCE: 0.05, // 5%
  BASE_CRIT_MULTIPLIER: 1.5, // 150%

  // Dodge
  MAX_DODGE_CHARGES: 3,
  DODGE_RECHARGE_TIME: 3, // seconds
  DODGE_I_FRAMES: 0.3, // seconds
  DODGE_SPEED_MULTIPLIER: 3,

  // Player combat
  PLAYER_BASE_SPEED: 150,
  PLAYER_BASE_ARMOR: 10,
  PLAYER_BASE_EVASION: 5,
  BASE_MANA_REGEN: 2,          // Mana per second
  BLOOD_MAGIC_COST_MULT: 0.7,  // 30% cost reduction
  MAX_CDR_PERCENT: 75,          // Cooldown reduction cap
  MIN_CAST_SPEED_MULT: 0.1,    // Minimum cast speed multiplier
  MIN_ATTACK_SPEED_MULT: 0.2,  // Minimum attack speed multiplier
  MIN_MOVE_SPEED_MULT: 0.2,   // Minimum movement speed multiplier
  SKILL_ANIMATION_COOLDOWN: 0.2,
  MIN_GLOBAL_AOE_COOLDOWN: 0.3,
  KNOCKBACK_DECAY_RATE: 10,
  KNOCKBACK_THRESHOLD: 0.1,    // Minimum knockback velocity before stopping

  // Effect stone caps
  MAX_SLOW_PERCENT_FROM_STONES: 60,

  // Enemy AI
  IDLE_WANDER_CHANCE: 0.3,
  IDLE_MOVE_SPEED_MULT: 0.3,
  DEAGGRO_RANGE_MULT: 1.5,
  ATTACK_LEASH_MULT: 1.2,
} as const;

// ========================
// Item Constants
// ========================

export const ITEM = {
  MAX_PREFIXES: 3,
  MAX_SUFFIXES: 3,
  MAX_ENHANCEMENT: 15,

  // Rarity colors
  COLORS: {
    normal: '#a0a0a0',
    magic: '#5c8ed4',
    rare: '#d4c45c',
    set: '#2ecc71',
    legendary: '#d4875c',
  },
} as const;

// ========================
// UI Colors
// ========================

export const COLORS = {
  BACKGROUND: '#1a1410',
  PANEL: '#2d241c',
  TEXT: '#f4e8d4',
  ACCENT: '#d4a84b',
  HP: '#c24a4a',
  MANA: '#4a7cc2',
  ENERGY_SHIELD: '#8a5ac2',
  SUCCESS: '#5cd47a',
  ERROR: '#d45c5c',
  WARNING: '#d4a84b',
} as const;

// ========================
// Element Data
// ========================

export const ELEMENTS = {
  physical: { name: 'Fiziksel', icon: '⚔️', color: '#dadada' },
  od: { name: 'Od', icon: '🔥', color: '#da7e7e' },
  su: { name: 'Su', icon: '❄️', color: '#7edada' },
  gok: { name: 'Gök', icon: '⚡', color: '#7eb8da' },
  karanlik: { name: 'Karanlık', icon: '💀', color: '#9b59b6' },
} as const;

// ========================
// Key Bindings
// ========================

export * from './KeyBindings';
